export var BackupZeroEtlIdentityColumnField;
(function (BackupZeroEtlIdentityColumnField) {
    BackupZeroEtlIdentityColumnField["BACKUP_ZERO_ETL_IDENTITY_COLUMN_FIELD_SOURCE_CLOUD"] = "SOURCE_CLOUD";
    BackupZeroEtlIdentityColumnField["BACKUP_ZERO_ETL_IDENTITY_COLUMN_FIELD_SOURCE_ACCOUNT_ID"] = "SOURCE_ACCOUNT_ID";
    BackupZeroEtlIdentityColumnField["BACKUP_ZERO_ETL_IDENTITY_COLUMN_FIELD_SOURCE_REGION"] = "SOURCE_REGION";
    BackupZeroEtlIdentityColumnField["BACKUP_ZERO_ETL_IDENTITY_COLUMN_FIELD_RESOURCE_ID"] = "RESOURCE_ID";
    BackupZeroEtlIdentityColumnField["BACKUP_ZERO_ETL_IDENTITY_COLUMN_FIELD_DATABASE_NAME"] = "DATABASE_NAME";
    BackupZeroEtlIdentityColumnField["BACKUP_ZERO_ETL_IDENTITY_COLUMN_FIELD_SCHEMA_NAME"] = "SCHEMA_NAME";
    BackupZeroEtlIdentityColumnField["BACKUP_ZERO_ETL_IDENTITY_COLUMN_FIELD_TABLE_NAME"] = "TABLE_NAME";
})(BackupZeroEtlIdentityColumnField || (BackupZeroEtlIdentityColumnField = {}));
